import { THEME } from '../../../cms/layout/types';
import { getBgColor } from '../../../cms/layout/util';
import { DropdownOption } from '../styles';
import { PRODUCT_OPTION } from './DropdownList.data';

type MoreDropdownProps = {
  activeState: boolean;
  logoutFunction?: () => void;
  theme: THEME;
};

type GeneralDropdownProps = {
  activeState: boolean;
  logoutFunction?: () => void;
  dropdownList?: Array<{ name: string; link: string }>;
  language?: string;
  theme: THEME;
};

type TProductOptionChild = {
  name: string;
  child: Array<{
    title: string;
    url: string;
    icon?: string;
    id: string;
  }>;
};

export const SolutionsDropdownMobile = (
  props: MoreDropdownProps
): JSX.Element => {
  return (
    <div
      className={` ${
        props.activeState ? '' : 'hidden'
      } origin-top-right rounded-md shadow-md sm:shadow-none z-10 pt-2 focus:outline-none overflow-auto sm:overflow-y-scroll max-h-viewport-75`}
      role="menu"
      aria-orientation="vertical"
      aria-labelledby="menu-button"
      tabIndex={-1}
    >
      <div className={`${getBgColor(props.theme)}`}>
        <div className="flex flex-wrap px-8 py-8 sm:px-0 sm:py-4">
          {PRODUCT_OPTION.map((ele: TProductOptionChild) => (
            <div className="w-full px-4 pb-5" key={ele.name}>
              <div className="w-full  pb-5">
                <h6 className="text-base font-semibold text-gray-600">
                  {ele.name}
                </h6>
              </div>
              {ele.child.map((item) => (
                <DropdownOption key={item.id}>
                  <a
                    href={item.url}
                    target="_blank"
                    className={`${
                      props.theme === THEME.dark
                        ? 'text-gray-200'
                        : 'text-gray-700'
                    } block py-4 font-md text-sm hover:text-green-400 sm:py-2`}
                    role="menuitem"
                    tabIndex={-1}
                    id={`menu-item-${item.title}`}
                    rel="noreferrer"
                  >
                    {item.title}
                  </a>
                </DropdownOption>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export const SolutionsDropDown = (props: MoreDropdownProps): JSX.Element => {
  return (
    <div
      className={` ${
        props.activeState ? '' : 'hidden'
      } origin-top-right rounded-md shadow-md sm:shadow-none absolute z-10 -left-24 pt-0 focus:outline-none overflow-hidden sm:overflow-y-scroll sm:hidden max-h-viewport-75`}
      role="menu"
      aria-orientation="vertical"
      aria-labelledby="menu-button"
      tabIndex={-1}
      style={{ width: '42vw' }}
    >
      <div className={getBgColor(props.theme)}>
        <div className="flex px-8 py-8">
          {PRODUCT_OPTION.map((ele: TProductOptionChild) => (
            <div className="w-1/3 px-4" key={ele.name}>
              <div className="w-full  pb-5">
                <h6 className="text-base font-semibold text-font-300">
                  {ele.name}
                </h6>
              </div>
              {ele.child.map((item) => (
                <DropdownOption key={item.id}>
                  <a
                    href={item.url}
                    target="_blank"
                    className={`${
                      props.theme === THEME.dark
                        ? 'text-gray-200'
                        : 'text-gray-700'
                    } block px-4 py-4 font-md text-sm hover:text-green-400 whitespace-nowrap`}
                    role="menuitem"
                    tabIndex={-1}
                    id={`menu-item-${item.title}`}
                    rel="noreferrer"
                  >
                    {item.title}
                  </a>
                </DropdownOption>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export const GeneralDropdown = ({
  activeState,
  dropdownList,
  theme,
}: GeneralDropdownProps): JSX.Element => (
  <div
    className={` ${
      activeState ? '' : 'hidden'
    } origin-top-right absolute z-10 left-5 pt-0 w-56 focus:outline-none sm:relative sm:w-full sm:left-0 sm:pl-0 sm:overflow-y-scroll max-h-viewport-75`}
    role="menu"
    aria-orientation="vertical"
    aria-labelledby="menu-button"
    tabIndex={-1}
  >
    <div
      className={`py-1 rounded-md shadow-lg   sm:shadow-none ${getBgColor(
        theme
      )}`}
      role="none"
    >
      {dropdownList &&
        dropdownList.map((ele: { name: string; link: string }) => (
          <DropdownOption key={ele.name}>
            <a
              href={ele.link}
              target="_blank"
              className={`${
                theme === THEME.dark ? 'text-gray-200' : 'text-gray-700'
              } block px-4 py-4 font-md text-sm hover:text-green-400 sm:py-2`}
              role="menuitem"
              tabIndex={-1}
              id={`menu-item-${ele.name}`}
              rel="noreferrer"
            >
              {ele.name}
            </a>
          </DropdownOption>
        ))}
    </div>
  </div>
);
